import * as React from "react";
import { forwardRef } from "react";
const SvgDashboardOutlined = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#979797" ref={ref} {...props}><path d="M0 0h24v24H0V0z" fill="none" /><path d="M19 5v2h-4V5h4M9 5v6H5V5h4m10 8v6h-4v-6h4M9 17v2H5v-2h4M21 3h-8v6h8V3zM11 3H3v10h8V3zm10 8h-8v10h8V11zm-10 4H3v6h8v-6z" /></svg>;
const ForwardRef = forwardRef(SvgDashboardOutlined);
export { ForwardRef as ReactComponent };
import __svgUrl from "/home/jenkins/agent/workspace/oorak_Connect_service_dev_master/src/icons/dashboardOutlined.svg?url";
export default __svgUrl;
